import * as yup from 'yup'

export default yup.object().shape({
  actionId: yup.string().min(1).required('Required field'),
})
